import { useEffect } from "react";

const ToastManager = ({ currentToast, setCurrentToast, toasts, dequeueToast }) => {
    useEffect(() => {
        if (currentToast === null && toasts.length) {
            dequeueToast();
        }
    }, [toasts, currentToast]);

    useEffect(() => {
        if (currentToast) {
            setTimeout(
                () => {
                    setCurrentToast(null);
                },
                currentToast.timeout ? currentToast.timeout : 3000
            );
        }
    }, [currentToast]);

    const closeError = () => {
        setCurrentToast(null);
    };

    return (
        <div className={`fixed bottom-16 left-1/2 transform -translate-x-1/2 z-50 ${!currentToast ? "hidden" : ""}`}>
            {currentToast ? (
                <div className={`relative flex justify-between ${currentToast.type === "error" ? "bg-[#E95E5E]" : "bg-green-500"} text-white text-xs p-4 shadow-lg rounded-xl min-w-[300px]`}>
                    <div>
                        {currentToast.type === "error" ? "Error: " : ""}
                        {currentToast.message}
                    </div>
                    <button onClick={closeError} className="ml-2">
                        x
                    </button>
                </div>
            ) : null}
        </div>
    );
};

export default ToastManager;
